import React from "react"
import Switch from "../Switch/Switch";

export default class FixedFooter extends React.Component{
  
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      const { current } = this.ref
      $(".modal-body").css({"margin-bottom": current.offsetHeight, "padding-bottom": "0px"})
    }, 100)
  }

  render() {
    return (
      <div ref={this.ref} className="accommodations-price-footer row p-0">
        <div className="col-sm-4"/>
        <div className="col-sm-4 d-flex align-items-center justify-content-center">
          <p className="lead" style={{ marginBottom: 0 }}>
            <label style={{ marginBottom: 0 }}>
              {this.props.label ? `${this.props.label}:` : null}
            </label>
            &nbsp;
            {this.props.text}
          </p>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 row justify-content-end p-0 pr-3">
          {this.renderSendEmailToggle()}
          {this.renderSendTextToggle()}
        </div>
      </div>
    );
  }

  renderSendEmailToggle(){
    if (this.props.showSendEmail) {
      return (
        <div className="d-flex align-items-center">
          <div>
            <label className="mb-n1">{I18n.t('send_email')} <span className="ss-help help" title={I18n.t('send_email_alert')}></span></label>
            <Switch 
              onText="yes" 
              offText="no" 
              onChange={this.props.onChangeSendEmail} 
              value={this.props.sendEmail} 
              switchId="send-email-switch"
            />
          </div>
        </div>
      )
    }
  }

  renderSendTextToggle(){
    if (this.props.showSendText) {
      return (
        <div className="d-flex align-items-center ml-3">
          <div>
            <label className="mb-n1">{I18n.t('send_text')} <span className="ss-help help" title={I18n.t('send_text_alert')}></span></label>
            <Switch 
              onText="yes" 
              offText="no" 
              onChange={this.props.onChangeSendText} 
              value={this.props.sendText} 
              switchId="send-text-switch"
            />
          </div>
        </div>
      )
    }
  }
};
